export default __webpack_public_path__ + "static/media/popup_money.4913af97.png";